import { lazy } from 'react'

export const KitResetMetabolismV1 = lazy(
  () => import('./kitV1/KitResetMetabolismV1'),
)
